var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1517",
    "data-name": "Ellipse 1517",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(16 16)",
    fill: "#ff5a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164577",
    "data-name": "Path 164577",
    d: "M175.837,146.517a29.907,29.907,0,0,1-29.32,29.32q-7.621-7.621-15.255-15.23a3.428,3.428,0,0,1,0-4.834l9.839-9.839-9.839-9.839a3.418,3.418,0,0,1,4.834-4.834l9.839,9.839,9.839-9.839a3.428,3.428,0,0,1,4.834,0q7.62,7.62,15.23,15.255Z",
    transform: "translate(-100.025 -100.025)",
    fill: "#db3a3c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164578",
    "data-name": "Path 164578",
    d: "M131.262,160.607a3.428,3.428,0,0,0,4.834,0l9.839-9.839,9.839,9.839a3.418,3.418,0,0,0,4.833-4.834l-9.839-9.839,9.839-9.839a3.418,3.418,0,1,0-4.834-4.833l-9.839,9.839-9.839-9.839a3.418,3.418,0,0,0-4.833,4.833l9.839,9.839-9.839,9.839A3.428,3.428,0,0,0,131.262,160.607Z",
    transform: "translate(-100.025 -100.025)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCross);
export default __webpack_public_path__ + "static/media/payment-cross.746603075240e4ce647bcb0116634b71.svg";
export { ForwardRef as ReactComponent };